import styled from 'styled-components';

const GroupStyle = styled.div`
    .back_icon{
        color: #000;
    }
    .user-menu-title{
        font-size: 1.424rem;
        font-weight: 700;
        line-height: 1.3;
        margin: 0px;
        word-break: break-word;
        hyphens: auto;
        text-align: left;
        margin-bottom: 0px;
    }
    .component_return_header{
        display: flex;
        justify-content: start;
        align-items: center;
        gap: 6px;
    }
    .yet-designed-pages{
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }
    .yet-designed-pages-image{
        width: 40%;
    }
    .developement-content{
        font-size: 1.266rem;
        line-height: 1;
        color: rgb(0, 0, 0);
        margin-bottom: 1rem;
    }
    .developement-span-content{
        font-size: 1.125rem;
        font-weight: 400;
        color: rgb(158, 165, 169);
        margin-bottom: 1rem;
    }
    .developement-add-button{
        font-size: 0.889rem;
        height: 2.5rem;
        min-width: 2.5rem;
        color: rgb(255, 255, 255);
        background-color: rgb(27, 104, 179);
        border: 1px solid rgb(27, 104, 179)
    }
    .group_view_header_con{
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .input_price_field{
        width: 100%;
    }
    .add_group_button_section{
        justify-content: flex-start;
        display: flex;

    }
    .group-menu-filter-container{
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .search-input-field{
        margin-bottom: 0px !important;
    }
`;

export default GroupStyle;